// @flow strict

import styled from 'styled-components';

export const PlantConfigurationWrapper = styled.div`
    height: 100%;
    width: 100%;
`;
